export enum SamplingPolicy {
  NotSet = 0,
  Measure = 1,
  Diagnostics = 2,
  CriticalBusinessImpact = 191,
  CriticalCensus = 192,
  CriticalExperimentation = 193,
  CriticalUsage = 194
}

export enum PersistencePriority {
  NotSet = 0,
  Normal = 1,
  High = 2
}

export enum CostPriority {
  NotSet = 0,
  Normal = 1,
  High = 2
}

/**
 * DataCategories
 * These can be combined with | as appropriate
 */
export enum DataCategories {
  NotSet = 0x00,
  SoftwareSetup = 0x01,
  ProductServiceUsage = 0x02,
  ProductServicePerformance = 0x04,
  DeviceConfiguration = 0x08,
  InkingTypingSpeech = 0x10
}

/**
 * The diagnostic level of the event
 * For generic events, a user can be set to send no events, only basic events, or all (full and basic) events.
 * Services can also send events that are necessary for them to function; these are not affected by the above setting.
 * Instead, if the service is turned off, then it will stop functioning and no NecessaryServiceDataEvents will be sent.
 * AlwaysOnNecessaryServiceDataEvents are always on.
 */
export enum DiagnosticLevel {
  ReservedDoNotUse = 0,
  BasicEvent = 10,
  FullEvent = 100,
  NecessaryServiceDataEvent = 110,
  AlwaysOnNecessaryServiceDataEvent = 120
}
